export default __webpack_public_path__ + "assets/fonts/Segoe UI Bold.ttf";